import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { 
  FaCamera, FaEdit, FaCheckCircle, FaToggleOn, FaToggleOff, FaPhone, FaEnvelope, 
  FaMapMarkerAlt, FaIdBadge, FaShieldAlt, FaBell, FaCreditCard, FaFileAlt, 
  FaQuestionCircle, FaLock, FaBook, FaSignOutAlt, FaChevronRight 
} from "react-icons/fa";
import "../../../styles/Header-css/ServicePartner/PartnerProfile/ProfileSettings.css";

const ProfileSettings = () => {
  const [profileData, setProfileData] = useState({
    fullname: "Giish",
    email: "giripayla@gmail.com",
    phone: "9391571143",
    address: "Indiranagar, Bangalore",
  });

  // State for toggles
  const [isAvailable, setIsAvailable] = useState(true);
  const [notifications, setNotifications] = useState(true);

  // Load data from localStorage on component mount
  useEffect(() => {
    try {
      const storedProfile = localStorage.getItem("partnerProfile");
      if (storedProfile) {
        setProfileData(JSON.parse(storedProfile));
      }
    } catch (error) {
      console.error("Failed to parse partner profile from localStorage:", error);
    }
  }, []);
  
  // Note: Edit/Save functionality would typically be on a separate page or in a modal.
  // The "Edit" button is here for visual representation.

  return (
    <div className="profile-page-container">
      {/* --- Profile Header --- */}
      <header className="profile-header">
        <div className="profile-avatar-wrapper">
          <img src="https://via.placeholder.com/100" alt="Profile" className="profile-avatar" />
          <button className="avatar-edit-btn"><FaCamera /></button>
        </div>
        <div className="profile-info">
          <h1>Hello, {profileData.fullname}!</h1>
          <div className="profile-meta">
            <span className="rating">⭐ 4.8</span>
            <span className="jobs">0 jobs</span>
          </div>
          <div className="profile-tags">
            <span className="tag verified"><FaCheckCircle /> Verified</span>
            <span className="tag available">Available</span>
          </div>
        </div>
        <button className="edit-profile-btn"><FaEdit /> Edit</button>
      </header>

      {/* --- Two-Column Layout for Main Content --- */}
      <main className="profile-main-content">
        
        {/* -- Left Column -- */}
        <div className="profile-left-column">
          <div className="profile-card">
            <h3 className="card-title">Availability Status</h3>
            <div className="card-item toggle-item">
              <span>You are currently accepting new bookings</span>
              <button className="toggle-btn" onClick={() => setIsAvailable(!isAvailable)}>
                {isAvailable ? <FaToggleOn className="active" /> : <FaToggleOff />}
              </button>
            </div>
          </div>

          <div className="profile-card">
            <h3 className="card-title">Contact Information</h3>
            <div className="card-item"><FaPhone /><p>{profileData.phone}</p><FaCheckCircle className="verified-icon"/></div>
            <div className="card-item"><FaEnvelope /><p>{profileData.email}</p><FaCheckCircle className="verified-icon"/></div>
            <div className="card-item"><FaMapMarkerAlt /><p>{profileData.address}</p><FaCheckCircle className="verified-icon"/></div>
          </div>

          <div className="profile-card">
            <h3 className="card-title">Verification Status</h3>
            <div className="card-item"><FaPhone /><p>Phone Number</p><FaCheckCircle className="verified-icon"/></div>
            <div className="card-item"><FaEnvelope /><p>Email Address</p><FaCheckCircle className="verified-icon"/></div>
            <div className="card-item"><FaMapMarkerAlt /><p>Address Proof</p><FaCheckCircle className="verified-icon"/></div>
            <div className="card-item"><FaIdBadge /><p>ID Proof</p><FaCheckCircle className="verified-icon"/></div>
            <div className="card-item"><FaShieldAlt /><p>Background Check</p><FaCheckCircle className="verified-icon"/></div>
          </div>

           <div className="profile-card">
            <h3 className="card-title">Active Services</h3>
            <div className="services-pills">
                <span className="service-pill">Plumber</span>
                <span className="service-pill">Electrical</span>
            </div>
             <button className="manage-services-btn"><FaEdit /> Manage</button>
          </div>
        </div>

        {/* -- Right Column -- */}
        <div className="profile-right-column">
          <div className="profile-card settings-links">
             <div className="card-item toggle-item link-item">
                <div className="link-content"><FaBell /><p>Notification</p></div>
                <button className="toggle-btn" onClick={() => setNotifications(!notifications)}>
                    {notifications ? <FaToggleOn className="active" /> : <FaToggleOff />}
                </button>
            </div>
            <Link to="/payment-settings" className="card-item link-item">
                <div className="link-content"><FaCreditCard /><p>Payment Settings</p></div>
                <FaChevronRight />
            </Link>
             <Link to="/documents" className="card-item link-item">
                <div className="link-content"><FaFileAlt /><p>Document</p></div>
                <FaChevronRight />
            </Link>
            <Link to="/help-support" className="card-item link-item">
                <div className="link-content"><FaQuestionCircle /><p>Help & Support</p></div>
                <FaChevronRight />
            </Link>
            <Link to="/privacy-policy" className="card-item link-item">
                <div className="link-content"><FaLock /><p>Privacy & Policy</p></div>
                <FaChevronRight />
            </Link>
            <Link to="/terms-of-service" className="card-item link-item">
                <div className="link-content"><FaBook /><p>Terms of Service</p></div>
                <FaChevronRight />
            </Link>
          </div>

          <button className="sign-out-btn">
            <FaSignOutAlt /> Sign Out
          </button>
        </div>

      </main>
    </div>
  );
};

export default ProfileSettings;